export default {
  code: 'IQ',
  countryName: 'IRQ',
  // googleSiteVerificationCode: '',
  googleSiteVerificationCode: [],
  countryDomain: 'https://www.carrefour.iq',
  helplineNumber: '',
  latitude: 33.312805,
  longitude: 44.361488,
  defaultAreaCode: '',
  features: {
    languageChange: false,
    now: false,
    share: false,
    isLocationCXEnable: false,
    isNewAddress: false,
    cashback: false,
    linkMyClubCard: false,
    oneTrustScript: '7b6b5333-d9fd-485c-ab38-1c20ddbb0ee0'
  }
}
